<template>
  <!--콘텐츠 영역-->

  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item">
      <div class="tit">
        <h3 class="fNS-EB">연혁</h3>
        <span
          >2009년부터 지금까지,<br />
          페럼인프라가 걸어온 길을 안내해드립니다.
        </span>
      </div>
      <div class="txt">
        <ul class="history">
          <li>
            <h5>2022년</h5>
            <p>
              <span>05</span>
              우리금융 챔피언십
            </p>
            <p>
              <span>04</span>
              메디힐 한국일보 챔비언십
            </p>
          </li>

          <li>
            <h5>2021년</h5>
            <p><span>09</span>현대해상 최경주 인비테이셔널</p>
          </li>
          <li>
            <h5>2020년</h5>
            <p><span>01</span>MRO 사업 인수</p>
          </li>
          <li>
            <h5>2019년</h5>
            <p><span>05</span>제6회 교촌 허니레이디스 오픈 대회 개최</p>
          </li>
          <li>
            <h5>2018년</h5>
            <p><span>11</span>제15회 ADT캡스 KLGA대회 개최</p>
          </li>
          <li>
            <h5>2017년</h5>
            <p><span>12</span>동아일보 소비자만족 10대 골프장 선정</p>
            <p>
              <span>11</span>
              서울경제골프매거진 PAR4 TOP10홀 선정 (서코스 6번홀)
            </p>
            <p>
              <span>10</span>
              서울경제골프매거진 뉴커머 선정
            </p>
          </li>
          <li>
            <h5>2016년</h5>
            <p>
              <span>09</span>
              서울경제골프매거진 2016 한국 뉴코스 선정
            </p>

            <p>
              <span>09</span>
              골프다이제스트 2016~2017 베스트뉴코스 선정
            </p>
          </li>
          <li>
            <h5>2015년</h5>
            <p><span>09</span>이수그룹 제37회 KLPGA 대회 개최</p>
          </li>
          <li>
            <h5 rowspan="3">2014년</h5>
            <p><span>08</span> 고문성 대표이사 취임</p>
            <p>
              <span>06</span>
              페럼클럽 개장
            </p>
            <p>
              <span>04</span>
              페럼클럽 지점 설치
            </p>
          </li>
          <li>
            <h5>2012년</h5>
            <p><span>11</span>골프장 공사 착공</p>
          </li>
          <li>
            <h5>2010년</h5>
            <p><span>07</span>페럼타워 건물관리 착수</p>
          </li>
          <li>
            <h5>2009년</h5>
            <p><span>10</span>페럼인프라 회사 설립</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "HistoryTab.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/HistoryTab.vue